import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusToolbarActions], campus-toolbar-actions',
})
export class ToolbarActionsDirective {
  @HostBinding('class.shared-toolbar__actions')
  hasToolbarActions = true;

  @HostBinding('attr.data-cy')
  dataCy = 'toolbar-actions';
}
